export const IMG = {
  heroLibrary: "https://images.unsplash.com/photo-1782530707432-eb04674c3a5c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  heroWoman: "https://images.unsplash.com/photo-1581403341630-a6e0b9d2d257?crop=entropy&cs=srgb&fm=jpg&q=88&w=2000",
  student: "https://images.unsplash.com/photo-1752293946898-cbb41a899d65?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  africa: "https://images.unsplash.com/photo-1622295023876-0cdf583c41f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  math: "https://images.unsplash.com/photo-1758685848691-3933bc2aa3ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  collab: "https://images.unsplash.com/photo-1771557596027-1e95ac77c834?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  graduate: "https://images.unsplash.com/photo-1588619917602-0edc45186b96?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const SCHOOL_IMG = {
  "accelerated-studies": "https://images.unsplash.com/photo-1758685848691-3933bc2aa3ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "business-school": "https://images.unsplash.com/photo-1752293946898-cbb41a899d65?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "technology": "https://images.unsplash.com/photo-1622295023876-0cdf583c41f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "education-institute": "https://images.unsplash.com/photo-1782530707432-eb04674c3a5c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
};
